import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { useCallback, useContext, useEffect, useState } from "react";
import { Controller, useForm, useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import { FormInput } from "../../components/FormInput";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { checkDpSuccess, getFormErrorMessage, getMaskedString, setformate } from "../../utility/service/tool-service";
import { MessageContext, handleSuccessMessage } from "../../store/messageStore";
import {
  queryCompaniesInfo,
  queryCompanyTagList,
  B1020107Before,
  updateCompanyTagList,
} from "../../utility/service/company-service";
import { queryIndustryList } from "../../utility/service/register-service";
import { Calendar } from "primereact/calendar";
import {
  B2010202Before,
  B2010206Before,
  updateCompaniesEffective,
  updateCompaniesEffectiveInfo,
} from "../../utility/service/companybind-service";
import { SystemLoading, checkLoading } from "../../store/loadingStore";
import { getSubItemsByItemNo } from "../../utility/service/api-service";
import { addFormValidator } from "../../utility/validate/formValidator";
import { useFuncId } from "../../router/menuRouterMapper";
import { updateAuditEyesEvent } from "../../utility/service/audilog-service";
import { FormTextarea } from "../../components/FormTextarea";
import { MultiSelect } from "primereact/multiselect";
import PrimeDialog from "../../components/dialog/PrimeDialog";
import FormNumberInput from "../../components/FormNumberInput";

/***
 * actStatus = "0" (已審核) -> 展延
 * actStatus = "1" (待審核) -> 開通
 * **/
export default function CompanyBinding_Activate({ actStatus = "1" }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { itemObj, setItemObj, action, setAction, currentStatus, setCurrentStatus } = useOutletContext();
  const [detailObj, setDetailObj] = useState({});
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const [, loading] = useContext(SystemLoading);
  const [industryList, setIndustryList] = useState([]);
  const [effectiveTypeList, setEffectiveTypeList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [formRule, setFormRule] = useState([]); //表單驗證
  const [maskView, setMaskView] = useState(false);
  const chsFuncId = useFuncId();
  const [companyLevList, setCompanyLevList] = useState([]);
  const [tagList, setTagList] = useState([]);
  const [tagListModal, setTagListModal] = useState(false);
  const [originalTagList, setOriginalTagList] = useState([]);
  const [enableList, setEnableList] = useState([]);

  const useTypeList = [
    {
      label: t("company.a"),
      value: "A",
    },
    {
      label: t("company.b"),
      value: "B",
    },
    {
      label: t("company.m"),
      value: "M",
    },
  ];

  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    getValues,
    setValue,
    resetField,
    reset: resetForm,
    control,
    trigger,
    reset,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: {
      name: "",
      useTypes: [],
    },
    //錯誤驗證時機
    mode: "all",
  });

  const esgClientId = [
    {
      label: t("company.a"),
      value: "A",
    },
    {
      label: t("company.b"),
      value: "B",
    },
  ];

  useEffect(() => {
    if (action !== "") {
      axios_getSubItemsByItemNo("COMPANY_STATUS", 23).then(setStatusList);
      axios_getSubItemsByItemNo("EFFECTIVE_TYPE", 17).then(setEffectiveTypeList);
      axios_getSubItemsByItemNo("COMPANY_LEVEL", 35).then(setCompanyLevList);
      axios_getSubItemsByItemNo("COMPANY_LEVEL", 35).then(setCompanyLevList);
      axios_getSubItemsByItemNo("ENABLE_STATUS", 18).then(setEnableList);

      axios_queryIndustryList();
      axios_queryCompaniesInfo();
      axios_getCreateBefore(actStatus);
      axios_B1020107Before();
      axios_queryCompanyTagList();
    } else {
      btnBackTo();
    }
  }, [action]);

  const { fields: tagFields, append: addForm, remove: delForm } = useFieldArray({
    control,
    name: "editTagList",
  });

  //建立前查詢form 規則
  const axios_getCreateBefore = (actStatus) => {
    let apiBefore = actStatus === "1" ? B2010202Before : B2010206Before;
    apiBefore().then((res) => {
      if (checkDpSuccess(res)) {
        let array = [];
        res?.data?.RespBody?.constraints?.forEach((item) => {
          const result = addFormValidator(item?.field, res.data.RespBody.constraints);
          array.push(result);
        });
        setFormRule(array);
      }
    });
  };

  const axios_B1020107Before = () => {
    checkLoading(loading);
    B1020107Before()
      .then((res) => {
        if (checkDpSuccess(res)) {
          setFormRule(processConstraints(res?.data?.RespBody?.constraints));
        }
      })
      .finally(() => {
        checkLoading(loading, false);
      });
  };

  const processConstraints = (constraints) => {
    return constraints.map((item) => {
      if (item?.subObject?.value) {
        return { [item?.field]: processConstraints(item?.subObject.value) };
      } else {
        return addFormValidator(item?.field, constraints);
      }
    });
  };

  const setValidForm = useCallback(
    (formId) => {
      if (formRule?.length > 0) {
        const tmp = formRule?.find((item) => {
          return Object.keys(item)[0] === formId;
        });
        return tmp ? tmp[formId] : "";
      }
    },
    [formRule],
  );

  const setValidTagListForm = useCallback(
    (formId) => {
      if (setValidForm("tagList")?.length > 0) {
        const tmp = setValidForm("tagList")?.find((item) => {
          return Object.keys(item)[0] === formId;
        });
        return tmp ? tmp[formId] : "";
      }
    },
    [setValidForm("tagList")],
  );

  const handleResetForm = (index) => {
    delForm(index);
    addForm({ companiesTagSeq: "" });
    clearErrors();
  };

  const handleDelForm = (index, length) => {
    if (length > 1) {
      delForm(index);
    } else {
      delForm(index);
      addForm({ companiesTagSeq: "" });
    }
  };

  const axios_queryCompanyTagList = () => {
    queryCompanyTagList().then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody?.tagList;
        setTagList(data);
        setValue("editTagList", data);
      }
    });
  };

  const axios_updateCompanyTagList = () => {
    updateCompanyTagList({
      tagList: getValues("editTagList"),
    }).then((res) => {
      if (checkDpSuccess(res)) {
        handleSuccessMessage(dispatch, t("button.update") + " " + t("message.success"));
        axios_queryCompanyTagList();
        axios_queryCompaniesInfo();
      }
    });
  };

  const axios_getSubItemsByItemNo = (itemNo, orderNo) => {
    return getSubItemsByItemNo(itemNo, orderNo).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        return data.map((item, index) => ({
          ...item,
          index,
        }));
      }
      return [];
    });
  };

  const getLabelByValue = (value) => {
    const item = esgClientId?.find((item) => item.value === value);
    return item ? item.label : null;
  };

  const btnBackTo = () => {
    navigate("/management/companyBinding");
  };

  const checkKeyDown = (e) => {
    if (e.key === "Enter") e.preventDefault();
  };

  const inputCheckKeyDown = (e) => {
    //避免觸發 按enter 後 就觸發 onSubmit 事件冒泡 給input 使用 <FormInput enterClick事件 ; 一般input onKeyDown事件
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  //開通帳號
  const axios_updateCompaniesEffective = (reqBody) => {
    updateCompaniesEffective(reqBody).then((res) => {
      if (checkDpSuccess(res)) {
        handleSuccessMessage(dispatch, t("button.update") + " " + t("message.success"));
        btnBackTo();
      }
    });
  };

  //展延
  const axios_updateCompaniesEffectiveInfo = (reqBody) => {
    updateCompaniesEffectiveInfo(reqBody).then((res) => {
      if (checkDpSuccess(res)) {
        handleSuccessMessage(dispatch, t("extend") + " " + t("message.success"));
        btnBackTo();
      }
    });
  };

  const axios_queryCompaniesInfo = () => {
    checkLoading(loading);
    queryCompaniesInfo({ companySeq: itemObj?.companySeq })
      .then((res) => {
        let data = res?.data?.RespBody;
        setDetailObj(data);
        setValue("industryCode", data?.industryCode, { shouldValidate: true });
        setValue("status", data?.status, { shouldValidate: true });
        setValue("effectiveType", data?.effectiveType);
        setValue("effectiveStartDate", data?.effectiveStartDate !== null ? new Date(data?.effectiveStartDate) : "");
        setValue("effectiveEndDate", data?.effectiveEndDate !== null ? new Date(data?.effectiveEndDate) : "");
        setValue("companyLevel", data?.companyLevel);
        setValue("cfpReportQuota", data?.cfpReportQuota);
        setValue("s3BucketQuota", data?.s3BucketQuota);
        setValue("remark", data?.remark);
        setValue("tagList", data?.tagList);
        setValue("placesQuota", data?.placesQuota);
        setValue("cfvPlanQuota", data?.cfvPlanQuota);
        setValue("userQuota", data?.userQuota);
        setValue("cbamQuota", data?.cbamQuota);
        setValue("approveFlag", data?.approveFlag);
        setValue("maxRoleLevel", data?.maxRoleLevel);
        clearErrors();
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  const axios_queryIndustryList = () => {
    //取得行業別下拉清單
    queryIndustryList().then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody?.industryList;
        setIndustryList(data);
      }
    });
  };

  const axios_updateAuditEyesEvent = () => {
    updateAuditEyesEvent({
      functionId: chsFuncId,
      eventType: "E",
    }).then((res) => {
      if (checkDpSuccess(res)) {
      }
    });
  };

  const onSubmit = (data) => {
    let reqBody = {
      companySeq: detailObj?.companySeq,
      effectiveType: data.effectiveType,
      effectiveStartDate: setformate(data.effectiveStartDate, "YYYY/MM/DD"),
      effectiveEndDate: setformate(data.effectiveEndDate, "YYYY/MM/DD"),
      companyLevel: data?.companyLevel,
      s3BucketQuota: data?.s3BucketQuota,
      cfpReportQuota: data?.cfpReportQuota,
      remark: data?.remark,
      tagList: data?.tagList,
      placesQuota: data?.placesQuota,
      cfvPlanQuota: data?.cfvPlanQuota,
      userQuota: data?.userQuota,
      cbamQuota: data?.cbamQuota,
      approveFlag: data?.approveFlag,
      maxRoleLevel: data?.maxRoleLevel,
    };

    if (actStatus === "1") {
      //開通帳戶
      reqBody.status = data.status;
      if (data.status === "X") {
        //拒絕
        reqBody.effectiveType = null;
        reqBody.effectiveStartDate = null;
        reqBody.effectiveEndDate = null;
      }
      axios_updateCompaniesEffective(reqBody);
    } else if (actStatus === "0") {
      axios_updateCompaniesEffectiveInfo(reqBody);
    }
  };

  return (
    <>
      {/* 返回上頁 */}
      <div className="flex justify-content-between flex-wrap align-items-center">
        <div className="align-items-start">
          <Button
            rounded
            text
            onClick={() => {
              btnBackTo();
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
            {t("button.return_to_list")}
          </Button>
        </div>
      </div>
      <div className="" style={{ top: "28px" }}>
        <Button
          type="button"
          icon={`pi ${maskView ? "pi-eye" : "pi-eye-slash"}`}
          severity="secondary"
          onClick={() => {
            setMaskView((prev) => {
              if (!prev) {
                axios_updateAuditEyesEvent();
              }
              return !prev;
            });
          }}
        />
      </div>
      <div className="p-card">
        <div className="p-card-body">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid">
              {/*統一編號*/}
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("company_num")}</label>
                <span>{detailObj?.taxIdNum}</span>
              </div>
              {/*組織名稱*/}
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("org_name")}</label>
                <span>{detailObj?.name}</span>
              </div>
              {/* 行業代碼 */}
              <div className="col-12 lg:col-3">
                <label htmlFor="industryCode" className="form-label">
                  {t("industry")}
                </label>
                <Controller
                  name="industryCode"
                  control={control}
                  rules={{ required: { value: true, message: t("validation.required") } }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      disabled={true}
                      filter
                      optionLabel="industryName"
                      optionValue="industryCode"
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      name="industryCode"
                      control={control}
                      options={industryList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
                {getFormErrorMessage(errors, "industryCode")}
              </div>
              {/*類型*/}
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("type")}</label>
                <span>{getLabelByValue(detailObj?.type)}</span>
              </div>
            </div>
            <div className="grid my-1">
              {/*負責人*/}
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("companyLeader")}</label>
                <span>{!maskView ? getMaskedString("account", detailObj?.leader) : detailObj?.leader}</span>
              </div>
              {/*電子信箱*/}
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("companyEamil")}</label>
                <span>{!maskView ? getMaskedString("email", detailObj?.email) : detailObj?.email}</span>
              </div>
              {/*地址*/}
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("address")}</label>
                <span>{!maskView ? getMaskedString("address", detailObj?.address) : detailObj?.address}</span>
              </div>
            </div>
            <div className="grid my-1">
              {/* 狀態 */}
              <div className="col-12 lg:col-3">
                <label htmlFor="status" className="form-label required">
                  {t("status")}
                </label>
                <Controller
                  name="status"
                  control={control}
                  rules={setValidForm("status")}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      disabled={actStatus === "0"}
                      filter
                      optionLabel="subitemName"
                      optionValue="subitemNo"
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      name="status"
                      control={control}
                      options={statusList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
                {getFormErrorMessage(errors, "status")}
              </div>
              {/*授權類型*/}
              <div className="col-12 lg:col-3">
                <label className={`form-label ${watch("status") !== "X" ? "required" : ""}`}>
                  {t("authorizationType")}
                </label>
                <Controller
                  name="effectiveType"
                  control={control}
                  // rules={{required: { value: watch("status")==='X'?false:true, message: t('validation.required') }}}
                  rules={setValidForm("effectiveType")}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      disabled={watch("status") === "X"}
                      filter
                      optionLabel="subitemName"
                      optionValue="subitemNo"
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      name="effectiveType"
                      control={control}
                      options={effectiveTypeList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
                {getFormErrorMessage(errors, "effectiveType")}
              </div>
              {/*授權起訖日*/}
              <div className="col-12 lg:col-6">
                <label htmlFor="useTypes" className={`form-label ${watch("status") !== "X" ? "required" : ""}`}>
                  {t("authorizationDate")}
                </label>
                <div className="col-date-picker">
                  <Controller
                    name="effectiveStartDate"
                    control={control}
                    rules={{
                      required: { value: watch("status") === "X" ? false : true, message: t("validation.required") },
                      validate: (val) => {
                        if (val !== "" && watch("effectiveEndDate") !== "" && watch("effectiveEndDate") < val)
                          return t("validation.startDate");
                      },
                    }}
                    render={({ field, fieldState, formState }) => (
                      <Calendar
                        className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                        dateFormat="yy-mm-dd"
                        disabled={action === "detail" || watch("status") === "X"}
                        value={field.value || ""}
                        onChange={(e) => {
                          field.onChange(e.value);
                          if (e.value < watch("effectiveEndDate")) {
                            clearErrors("effectiveEndDate");
                          }
                        }}
                        showIcon
                      />
                    )}
                  />
                  {getFormErrorMessage(errors, "effectiveStartDate")}

                  <Controller
                    name="effectiveEndDate"
                    control={control}
                    rules={{
                      required: { value: watch("status") === "X" ? false : true, message: t("validation.required") },
                      validate: (val) => {
                        if (val !== "" && watch("effectiveStartDate") !== "" && watch("effectiveStartDate") > val)
                          return t("validation.endDate");
                      },
                    }}
                    render={({ field, fieldState, formState }) => (
                      <Calendar
                        className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                        dateFormat="yy-mm-dd"
                        disabled={action === "detail" || watch("status") === "X"}
                        value={field.value || ""}
                        onChange={(e) => {
                          field.onChange(e.value);
                          if (e.value > watch("effectiveStartDate")) {
                            clearErrors("effectiveStartDate");
                          }
                        }}
                        showIcon
                      />
                    )}
                  />
                  {getFormErrorMessage(errors, "effectiveEndDate")}
                </div>
              </div>
              {/* <div className='col-12 lg:col-3'>
                    <label
                        className="form-label">
                        {t("authorizationDate")}
                    </label>
                    <span>{detailObj?.effectiveStartDate} ~ {detailObj?.effectiveEndDate}</span>
                </div> */}
            </div>
            <div className="grid">
              {/*會員等級*/}
              <div className="col-12 lg:col-3">
                <label className={`form-label ${watch("status") !== "X" ? "required" : ""}`}>
                  {t("membershipLevel")}
                </label>
                <Controller
                  name="companyLevel"
                  control={control}
                  rules={{
                    required: { value: watch("status") === "X" ? false : true, message: t("validation.required") },
                  }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      disabled={watch("status") === "X"}
                      optionLabel="subitemName"
                      optionValue="subitemNo"
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      options={companyLevList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
              </div>
              {/*檔案上傳容量上限(GB)*/}
              <div className="col-12 lg:col-3">
                <FormNumberInput
                  disabled={watch("status") === "X"}
                  register={register}
                  errors={errors}
                  id="s3BucketQuota"
                  name="s3BucketQuota"
                  labelText={t("s3BucketQuota")}
                  labelClass={`form-label ${watch("status") !== "X" ? "required" : ""}`}
                  enterClick={inputCheckKeyDown}
                  rules={setValidForm("s3BucketQuota")}
                  value={watch("s3BucketQuota")}
                  onChange={(newValue) => setValue("s3BucketQuota", newValue)}
                />
              </div>
              {/*碳足跡可用件數*/}
              <div className="col-12 lg:col-3">
                <FormNumberInput
                  disabled={watch("status") === "X"}
                  register={register}
                  errors={errors}
                  id="cfpReportQuota"
                  name="cfpReportQuota"
                  labelText={t("cfpReportQuota")}
                  labelClass={`form-label ${watch("status") !== "X" ? "required" : ""}`}
                  enterClick={inputCheckKeyDown}
                  rules={setValidForm("cfpReportQuota")}
                  value={watch("cfpReportQuota")}
                  onChange={(newValue) => setValue("cfpReportQuota", newValue)}
                />
              </div>
              {/*可建立場所數*/}
              <div className="col-12 lg:col-3">
                <FormNumberInput
                  disabled={watch("status") === "X"}
                  register={register}
                  errors={errors}
                  id="placesQuota"
                  name="placesQuota"
                  labelText={t("placeCreateCount")}
                  labelClass={`form-label ${watch("status") !== "X" ? "required" : ""}`}
                  enterClick={inputCheckKeyDown}
                  rules={setValidForm("placesQuota")}
                  value={watch("placesQuota")}
                  onChange={(newValue) => setValue("placesQuota", newValue)}
                />
              </div>
              {/*可建立盤查計劃數*/}
              <div className="col-12 lg:col-3">
                <FormNumberInput
                  disabled={watch("status") === "X"}
                  register={register}
                  errors={errors}
                  id="cfvPlanQuota"
                  name="cfvPlanQuota"
                  labelText={t("planCreateCount")}
                  labelClass={`form-label ${watch("status") !== "X" ? "required" : ""}`}
                  enterClick={inputCheckKeyDown}
                  rules={setValidForm("cfvPlanQuota")}
                  value={watch("cfvPlanQuota")}
                  onChange={(newValue) => setValue("cfvPlanQuota", newValue)}
                />
              </div>
              {/*可建立帳戶數*/}
              <div className="col-12 lg:col-3">
                <FormNumberInput
                  disabled={watch("status") === "X"}
                  register={register}
                  errors={errors}
                  id="userQuota"
                  name="userQuota"
                  labelText={t("accountCreateCount")}
                  labelClass={`form-label ${watch("status") !== "X" ? "required" : ""}`}
                  enterClick={inputCheckKeyDown}
                  rules={setValidForm("userQuota")}
                  value={watch("userQuota")}
                  onChange={(newValue) => setValue("userQuota", newValue)}
                />
              </div>
              {/*可建立CBAM數*/}
              <div className="col-12 lg:col-3">
                <FormNumberInput
                  disabled={watch("status") === "X"}
                  register={register}
                  errors={errors}
                  id="cbamQuota"
                  name="cbamQuota"
                  labelText={t("cbamCreateCount")}
                  labelClass={`form-label ${watch("status") !== "X" ? "required" : ""}`}
                  enterClick={inputCheckKeyDown}
                  rules={setValidForm("cbamQuota")}
                  value={watch("cbamQuota")}
                  onChange={(newValue) => setValue("cbamQuota", newValue)}
                />
              </div>
              {/*簽核功能*/}
              <div className="col-12 lg:col-3">
                <label className={`form-label ${watch("status") !== "X" ? "required" : ""}`}>
                  {t("approveFunction")}
                </label>
                <Controller
                  name="approveFlag"
                  control={control}
                  rules={{
                    required: { value: watch("status") === "X" ? false : true, message: t("validation.required") },
                  }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      disabled={watch("status") === "X"}
                      optionLabel="subitemName"
                      optionValue="subitemNo"
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      options={enableList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
              </div>
              {/*角色最高層數*/}
              <div className="col-12 lg:col-3">
                <FormNumberInput
                  disabled={watch("status") === "X"}
                  register={register}
                  errors={errors}
                  id="maxRoleLevel"
                  name="maxRoleLevel"
                  labelText={t("roleMaxLevel")}
                  labelClass={`form-label ${watch("status") !== "X" ? "required" : ""}`}
                  enterClick={inputCheckKeyDown}
                  rules={setValidForm("maxRoleLevel")}
                  value={watch("maxRoleLevel")}
                  onChange={(newValue) => setValue("maxRoleLevel", newValue)}
                />
              </div>
            </div>
            {/*備註*/}
            <div className="grid">
              <div className="col-6">
                <label htmlFor="tagList" className="form-label">
                  {t("tag")}
                  <Button
                    type="button"
                    size="small"
                    text
                    severity="secondary"
                    icon="pi pi-cog"
                    label={`${t("button.edit")}${t("tag")}`}
                    onClick={() => {
                      setOriginalTagList(tagFields);
                      setTagListModal(true);
                    }}
                    style={{ margin: "0px 1rem", padding: "0px" }}
                  />
                </label>
                <Controller
                  name="tagList"
                  control={control}
                  render={({ field }) => (
                    <MultiSelect
                      filter
                      showClear
                      className="w-full"
                      style={{ width: "100%" }}
                      display="chip"
                      options={tagList}
                      optionLabel={"tagName"}
                      optionValue={"companiesTagSeq"}
                      value={field.value}
                      onChange={(e) => {
                        field.onChange(e.value);
                      }}
                    ></MultiSelect>
                  )}
                />
              </div>

              <div className="col-12">
                <FormTextarea
                  register={register}
                  errors={errors}
                  id="remark"
                  name="remark"
                  type="text"
                  labelText={t("remark")}
                  areaClass="w-full"
                  rules={setValidForm("technicalDescription")}
                />
              </div>
            </div>
            <div className="grid">
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("create_user")}</label>
                <span>{detailObj?.createUser}</span>
              </div>
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("create_date")}</label>
                <span>{detailObj?.createDateTime}</span>
              </div>
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("update_user")}</label>
                <span>{detailObj?.updateUser}</span>
              </div>
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("update_date")}</label>
                <span>{detailObj?.updateDateTime}</span>
              </div>
            </div>
            <div className="col-12 gap-2 flex-all-center">
              <Button
                disabled={!isValid || watch("status") === "1"}
                type="submit"
                label={t("button.confirm")}
                size="small"
              />
              <Button
                outlined
                size="small"
                type="button"
                label={t("button.cancel")}
                onClick={(e) => {
                  btnBackTo();
                }}
              />
            </div>
          </form>
        </div>
      </div>

      <PrimeDialog
        visible={tagListModal}
        size="lg"
        disabledConfirm={false}
        onClose={() => {
          const currentValues = getValues();
          reset({
            ...currentValues,
            editTagList: originalTagList,
          });
          setTagListModal(false);
        }}
        onConfirm={() => {
          axios_updateCompanyTagList();
          setTagListModal(false);
        }}
        title={t("button.update")}
        bodyTemplate={
          <>
            {tagFields.map((item, index) => (
              <div key={index} className="grid">
                <div className="col-5">
                  <FormInput
                    register={register}
                    errors={errors}
                    id={`editTagList[${index}].tagName`}
                    name={`editTagList[${index}].tagName`}
                    labelText={t("productName")}
                    labelClass="required"
                    rules={setValidTagListForm(`tagName`)}
                  />
                </div>
                <div className="col-6">
                  <FormTextarea
                    register={register}
                    errors={errors}
                    id={`editTagList[${index}].tagDetail`}
                    name={`editTagList[${index}].tagDetail`}
                    text="text"
                    labelText={t("descript")}
                    labelClass="required"
                    rows={1}
                    rules={setValidTagListForm(`tagDetail`)}
                  />
                </div>
                <div className="col-1">
                  <button
                    type="button"
                    className="icon-btn"
                    onClick={() => {
                      tagFields?.length === 1 ? handleResetForm(index) : handleDelForm(index, tagFields?.length);
                    }}
                  >
                    <i className="pi pi-minus"></i>
                  </button>
                </div>
              </div>
            ))}

            <div className="form-group">
              <button
                type="button"
                className="icon-btn"
                onClick={() => {
                  addForm({ companiesTagSeq: "" });
                }}
              >
                <i className="pi pi-plus"></i>
              </button>
            </div>
          </>
        }
      />
    </>
  );
}
